<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse" aria-expanded="false" aria-controls="collapse">
                Wat valt onder 'Negatieve persoonsgebonden aftrek'
            </button>
        </h2>
        <div id="collapse" class="accordion-collapse collapse" aria-labelledby="heading"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                We hebben het hier over in {{ this.year }} teruggekregen bedrag of vergoeding voor bedragen die je al
                vóór {{ this.year }} hebt afgetrokken. In dat geval moet je deze aftrek in je aangifte
                over {{ this.year }}herstellen.
                <div class="space10"></div>

                <b>Voorbeeld</b><br/>
                Je hebt in {{ this.year - 2 }} zorgkosten betaald, die je in je aangifte over {{ this.year - 2 }} hebt
                afgetrokken. In {{ this.year }} heeft de werkgever (een deel van) deze zorgkosten op zich genomen. Je
                had daar geen recht op, maar op deze wijze wil je werkgever waardering voor je inzet laten zien.
                Achteraf gezien heb je ten onrechte de aftrek in {{ this.year - 2 }} geclaimd, omdat de kosten niet op
                je drukken. In dat geval moet je deze aftrek in je aangifte over{{ this.year }} herstellen. Je hoeft
                nooit meer aan te geven dan het bedrag dat je eerder hebt afgetrokken.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Om welke teruggekregen bedragen en vergoedingen gaat het
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat om teruggekregen bedragen en vergoedingen voor:
                <li class="list">partneralimentatie en andere onderhoudsverplichtingen</li>
                <li class="list">zorgkosten</li>
                <li class="list">een gift die onder een ontbindende voorwaarde is gedaan, en die ontbonden of herroepen
                    is. Het gaat om een gift die je in een eerdere aangifte hebt afgetrokken.
                </li>
                <li class="list">studiekosten en andere scholingsuitgaven die je sinds 2001 hebt afgetrokken</li>
            </div>
        </div>
    </div>

</div>



